export interface CssConfig {
    bgColor?: string;
    borderRadius?: string;
    color?: string;
    fontSize?: string;
    maxWidth?: string;
}

export const brandImages = [
    { brandName: "charity", logoUrl: "assets/images/brand-logo/charity-navigator.webp", whitelogo: "assets/images/brand-logo/charity-white.webp", href: "https://www.charitynavigator.org/"},
    { brandName: "guidestar", logoUrl: "assets/images/brand-logo/guidestar.webp", whitelogo: "assets/images/brand-logo/guidestar-white.webp", href: "https://www.guidestar.org/"},
    { brandName: "bbb", logoUrl: "assets/images/brand-logo/bbb.webp", whitelogo: "assets/images/brand-logo/bbb-white.webp", href: "https://www.bbb.org/"},
    { brandName: "irs", logoUrl: "assets/images/brand-logo/irs.webp", whitelogo: "assets/images/brand-logo/irs-white.webp", href: "https://www.irs.gov/"},
]